import { z } from 'zod';
// import {
//     complectationOptionRawValueToUIFormValue,
//     ComplectationOptionsCreateForm,
//     ComplectationOptionsUIUpdateForm, makeComplectationOptionsEmptyUICreateForm,
// } from '@/types/complectation.type.ts';

export type CarDecodedComplectation = {
    id: number,
    code: string,
    options: {
        code: string,
        value: string,
    }[],
};

// export function mapCarDecodedComplectationToComplectationOptionsUIUpdateForm(complectation: CarDecodedComplectation): ComplectationOptionsUIUpdateForm {
//     const options: ComplectationOptionsUIUpdateForm = makeComplectationOptionsEmptyUICreateForm();
//
//     complectation.options.forEach((option) => {
//         options[option.code as keyof ComplectationOptionsCreateForm] = complectationOptionRawValueToUIFormValue(option.code, option.value);
//     });
//
//     return options;
// }

export const CarDecodedComplectationSchema = z.object({
    id: z.number(),
    code: z.string(),
    options: z.array(z.object({
        code: z.string(),
        value: z.string(),
    })),
});

// export const CarDecodedComplectationsSchema = z.array(CarDecodedComplectationSchema);
